import { observable, action } from 'mobx';
import axios from 'axios';

class SavingsStore {
  @observable accessor textDownloadReport = '';

  constructor() {
    this.downloadPdf = this.downloadPdf.bind(this);
    this.setTextDownloadReport = this.setTextDownloadReport.bind(this);
  }

  @action
  async downloadPdf(formData) {

    const formattedFormdata = {
      ...formData,
      nhg: formData.nhg === 1,
      labelName: 'WelThuis',
      forceAutoRiskClassReduction: false,
    };
    const postData = JSON.stringify(formattedFormdata);

    await axios.get(`/download/pdf?formdata=${postData}`)
      .then((response) => {
        this.responseError = '';
        window.location.href = `/download/serve-pdf/${response.data.token}`;
        setTimeout(() => {
          this.setTextDownloadReport('');
        }, 1000);
      })
      .catch(() => {
        this.responseError = 'Er is iets mis gegaan tijdens het downloaden van het rapport. ' +
          'Probeer het later nog een keer.';
        this.setTextDownloadReport('');
      });
  }

  /* Set default termInterestSavingsSeries for use in SavingsGraphComponent and SavingsComponent */
  @observable accessor termInterestSavingsSeries = [{
    name: 'korting',
    data: [0, 0],
  }, {
    name: 'rente',
    data: [0, 0],
  }];

  @observable accessor loanpartsResult = {};

  @observable accessor assumptionsData = [
    { Verstrekker: '-' }, // find in providers with labelid
    { Product: '-' }, // van labelid
    { Hypotheekbedrag: '-' }, // calculation formstore
    { NHG: '-' }, // calculation formstore
    { Aflosvorm: 'Annuitair' }, // default annuitair
    { 'Looptijd hypotheek': '30 jaar' }, // 30 jaar
    { 'Looptijd rentevaste periode': '20 jaar' }, // 20 jaar
    { Aanvangsrente: '-' }, // call /calculate/interest-savings
  ];

  @action setTextDownloadReport(message) {
    this.textDownloadReport = message;
  }
}

const SavingsData = new SavingsStore();

export default SavingsData;
